import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SplitLanding.css';

const SplitLanding = () => {
  const [hoveredSide, setHoveredSide] = useState(null);

  return (
    <div className="split-landing">
      {/* Logo centered at top */}
      <div className="split-logo">
        <img src="/logo.png" alt="SVT Consulting" />
      </div>

      {/* Left Side - Smart Home */}
      <Link
        to="/smart-home"
        className={`split-side split-left ${hoveredSide === 'left' ? 'active' : ''} ${hoveredSide === 'right' ? 'inactive' : ''}`}
        onMouseEnter={() => setHoveredSide('left')}
        onMouseLeave={() => setHoveredSide(null)}
        style={{
          backgroundImage: `url('https://images.unsplash.com/flagged/photo-1572609239482-d3a83f976aa0?q=80&w=2832&auto=format&fit=crop')`
        }}
      >
        <div className="split-overlay"></div>
        <div className="split-content">
          <div className="split-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </div>
          <h2>Smart Home Solutions</h2>
          <p>Audio/Video • Security • Automation</p>
          <ul className="split-features">
            <li>Home Theater Systems</li>
            <li>CCTV & Security</li>
            <li>Smart Automation</li>
            <li>Whole-Home Audio</li>
          </ul>
          <span className="split-cta">
            Explore Smart Home
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </span>
        </div>
      </Link>

      {/* Right Side - Digital Development */}
      <Link
        to="/digital"
        className={`split-side split-right ${hoveredSide === 'right' ? 'active' : ''} ${hoveredSide === 'left' ? 'inactive' : ''}`}
        onMouseEnter={() => setHoveredSide('right')}
        onMouseLeave={() => setHoveredSide(null)}
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2340&auto=format&fit=crop')`
        }}
      >
        <div className="split-overlay"></div>
        <div className="split-content">
          <div className="split-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <polyline points="16 18 22 12 16 6"></polyline>
              <polyline points="8 6 2 12 8 18"></polyline>
            </svg>
          </div>
          <h2>Digital Development</h2>
          <p>Web • Mobile • Custom Software</p>
          <ul className="split-features">
            <li>Web Applications</li>
            <li>Mobile Apps (iOS & Android)</li>
            <li>Custom CRMs & Portals</li>
            <li>UI/UX Design</li>
          </ul>
          <span className="split-cta">
            Explore Digital
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </span>
        </div>
      </Link>

      {/* Divider Line */}
      <div className="split-divider">
        <div className="divider-line"></div>
        <div className="divider-or">OR</div>
        <div className="divider-line"></div>
      </div>
    </div>
  );
};

export default SplitLanding;
